const extractIndoorMapLink = (hrl) => {
  const linkMatch = hrl.match(/FPLink:(.*):FPLink/);
  const mapLink = linkMatch && linkMatch.length ? linkMatch[1] : null;
  const linkIndex = hrl.indexOf("FPLink:");
  const raw = linkIndex !== -1 ? hrl.substring(0, linkIndex) : hrl;

  const lines = raw.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  let floor = "", room = "";
  const otherLines = [];

  for (const line of lines) {
    if (line.startsWith("Floor:")) {
      floor = line.replace("Floor:", "").trim();
    } else if (line.startsWith("Room:")) {
      room = line.replace("Room:", "").trim();
    } else {
      otherLines.push(line);
    }
  }

  // Return structured data instead of HTML strings
  return { 
    mapLink, 
    parsedData: {
      floor,
      room,
      otherLines
    }
  };
};

export { extractIndoorMapLink };
